var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('reseller-payment-form',{attrs:{"loading":_vm.loading,"resellerPaymentData":_vm.resellerPayment,"formErrors":_vm.formErrors},on:{"resellerPaymentSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }